export const FormInvitationStatus = {
    Draft: "Draft",
    Invited: "Invited",
    Submitted: "Submitted",
    Approved: "Approved",
    Processing: "Processing",
    Completed: "Completed",
    Failed: "Failed",
    UnderReview: "Under Review",
  };
  export const FormInvitationUIStatus = {
    Processing: "Processing",
    Requested: "Requested",
    Started: "Started",
    Responded: "Responded",
    Approved: "Approved",
    Completed: "Completed",
    Failed: "Failed",
  };
  export const AppRoles = {
    Analytics: "Analytics",
    Approver: "Approver",
    Creator: "Creator",
    Invitee: "Invitee",
    Inviter: "Inviter",
    Platform: "Platform",
    Consultant: "Consultant",
    Responder: "Responder",
  };

  export const AIActions ={
    uploadDocuments: "upload-documents",
    documentProcessing : "document-processing"
  }
  export const AICommonValues={
    youtubeLink: "https://www.youtube.com/embed/VGlMFZaI5QA?si=Tr8P9DRt7qufJPY9"
  }
  export const bulkFileCurationStatus = {
    Pending: "Pending",
    Processing: "Processing",
    Completed: "Completed",
  };
  export const SourceFilesStatus = {
    Pending: "Pending",
    Ingesting: "Ingesting",
    Embedding: "Embedding",
    Success: "Success",
    Error: "Error",
    Curating: "Curating",
    Uploaded: "Uploaded",
  };

  export const FormTypes = {
    Assessment: "Assessment",
    Report: "Report",
  };
 
  export const FormTypesPage = {
    Assessments: "assessments",
    Reports: "reports",
  };

  export const ChatWithSnowkapAIPageKey = "ChatWithSnowkapAI";